import React from 'react';

export const DevDocs: React.FC = () => {
  return (
    <>
      <h1 className="dev-portal__title">API reference</h1>
      <p className="dev-portal__lede">
        Rendered from the OpenAPI 3.1 spec. Raw spec:{' '}
        <a href="/public-api/openapi.yaml" target="_blank" rel="noreferrer">
          /public-api/openapi.yaml
        </a>
        .
      </p>
      <div className="dev-portal__iframe-shell">
        <iframe title="BSO Public API reference" src="/public-api/docs.html" />
      </div>
    </>
  );
};
